export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	PRODUCT_TYPES = 'product-types',

	ADMINS = 'admins',
	USERS = 'users',

	ROLES = 'roles',
	CONTENTS = 'contents',
	USER_CONTENTS = 'user-contents',
	USER_COMPONENTS = 'user-components',

	MONTAGE_SYSTEMS = 'montage-systems',
	MONTAGE_TYPES = 'montage-types',
	ACCESSORIES = 'accessories',
	PRODUCT_COLORS = 'product-colors',
	COMPONENTS = 'components',
	DRIVERS = 'drivers',
	POWER_SUPPLIES = 'power-supplies',

	STORE_CONFIGURATION = 'store-configuration',

	USER_PROFILE = 'user-profile',
}
